// extracted by mini-css-extract-plugin
export default {"container":"PlanSent_container__BqgJ7","iconContainer":"PlanSent_iconContainer__8ZPd0","title":"PlanSent_title__GSBan"};